export const reverseGeocode = async (
  lat: number,
  lon: number,
  signal?: AbortSignal
): Promise<string | null> => {
  if (typeof navigator !== "undefined" && !navigator.onLine) {
    return null;
  }

  const url = new URL("https://nominatim.openstreetmap.org/reverse");
  url.searchParams.set("format", "jsonv2");
  url.searchParams.set("lat", lat.toString());
  url.searchParams.set("lon", lon.toString());

  const response = await fetch(url.toString(), {
    signal,
    headers: {
      "Accept-Language": "en"
    }
  });

  if (!response.ok) return null;
  const data = (await response.json()) as {
    display_name?: string;
  };

  return data.display_name ?? null;
};
